import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { MediaQuery } from '@uhg-abyss/web/ui/MediaQuery';
import { usePPDLagoon } from '../../../../tools/lagoon';
import { InfoCard } from './InfoCard';
import { PictureCard } from './PictureCard';

const StyledFlex = styled('div', {
  static: {
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
  },

  dynamic: ({ flex, alignContent, alignItems, justify, direction }) => {
    return {
      alignContent,
      alignItems,
      flex,
      flexDirection: direction,
      justifyContent: justify,
    };
  },
});

const Divider = styled('div', {
  width: '90%',
  borderBottom: '1px solid $gray4',
});

export const isDownloadLink = (linkToFile, isDownload) => {
  const extension = linkToFile.split('.').pop().toLowerCase();
  const extensionArray = ['pdf', 'docx', 'xlsx'];
  return (
    isDownload ||
    extensionArray.some((element) => {
      return element === extension;
    })
  );
};

export const UHCUpdates = () => {
  const { getUhcUpdates } = usePPDLagoon();

  const textOnlyUpdates = getUhcUpdates('right');
  const withPhotoUpdates = getUhcUpdates('left');

  return (
    <React.Fragment>
      <MediaQuery largerThan={984}>
        <StyledFlex justify='space-between'>
          <Grid>
            <Grid.Col span='60%'>
              <StyledFlex justify='space-evenly'>
                <For index='index' each='withPhotoUpdate' of={withPhotoUpdates}>
                  <PictureCard index={index} {...withPhotoUpdate} />
                </For>
              </StyledFlex>
            </Grid.Col>
            <Grid.Col span='40%'>
              <For index='index' each='textOnlyUpdate' of={textOnlyUpdates}>
                <If condition={index <= 2}>
                  <InfoCard {...textOnlyUpdate} />
                  <If condition={index !== textOnlyUpdates.length - 1}>
                    <Divider />
                  </If>
                </If>
              </For>
            </Grid.Col>
          </Grid>
        </StyledFlex>
      </MediaQuery>
      <MediaQuery smallerThan={984}>
        <StyledFlex direction='column' justify='space-evenly' align='start'>
          <For
            index='index'
            each='textOnlyUpdate'
            of={[...withPhotoUpdates, ...textOnlyUpdates]}
          >
            <If condition={index <= 4}>
              <InfoCard {...textOnlyUpdate} />
              <If
                condition={
                  index !== [...withPhotoUpdates, ...textOnlyUpdates].length - 1
                }
              >
                <Divider />
              </If>
            </If>
          </For>
        </StyledFlex>
      </MediaQuery>
    </React.Fragment>
  );
};
